const BlockActionExtractDefault = {
    name : "Extract from a variable",
    action_type : { name : "extract_data"},
    type : { name : 'action'},
    data : {
        before_after : { name: "before" },
        extract_input : null,
        extract_output : null,
        extract_type : { name: "number" },
        is_advance_extract : false,
        keywords_exclude : "",
        keywords_include : ""
    }
}

const BlockActionExtractServerDefault = {
    name : "Extract from a variable",
    action_type : "extract_data",
    before_after : "before",
    extract_type : "number",
    is_advance_extract : false
}

export {BlockActionExtractDefault, BlockActionExtractServerDefault }